/**
 * Sprint 156 — Cuando la sesión se vence, que se diga.
 *
 * ## El defecto que cierra
 *
 * La sesión del navegador dura doce horas y no se renueva sola. Al vencer, el
 * servidor empieza a contestar "se requiere iniciar sesión" a **todo**, y la
 * pantalla no hacía nada con esa respuesta: cada acción fallaba con un mensaje
 * distinto y ninguno decía la verdad. En la impresión salía disfrazado de
 * "no hay impresora", y la única forma de arreglarlo que encontró la dueña fue
 * cerrar el sistema y volver a entrar — a ciegas, sin saber por qué funcionaba.
 *
 * La caja abre a las diez y cierra pasada la medianoche en fin de semana: doce
 * horas caen justo dentro de una jornada, no fuera.
 *
 * ## Por qué un evento y no una excepción
 *
 * El aviso tiene que salir una sola vez y desde arriba, no en cada uno de los
 * cientos de puntos que llaman al servidor. Quien detecta (el transporte) no es
 * quien puede avisar (la pantalla), y no deben conocerse entre sí.
 */

/** Nombre del evento en `window`. Fuera del transporte nadie debería escribirlo. */
export const EVENTO_SESION_VENCIDA = 'pos:sesion-vencida';

/**
 * Sólo cuenta como sesión vencida un 401 del bridge de datos.
 *
 * Los canales de entrada (`/api/auth/…`) contestan 401 cuando el PIN está mal:
 * eso no es una sesión vencida, es un intento fallido, y confundirlos echaría a
 * la cajera de una pantalla en la que sí está autorizada.
 */
export function esSesionVencida(ruta: string, status: number): boolean {
  return status === 401 && ruta.startsWith('/ipc/');
}

export function avisarSesionVencida(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(EVENTO_SESION_VENCIDA));
}

export function alVencerSesion(fn: () => void): () => void {
  if (typeof window === 'undefined') return () => undefined;
  window.addEventListener(EVENTO_SESION_VENCIDA, fn);
  return () => window.removeEventListener(EVENTO_SESION_VENCIDA, fn);
}
